import { Link as GatsbyLink } from "gatsby";
import styled from "styled-components";

const Wrapper = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 10px;
  color: ${({ theme, $color }) =>
    $color === "purple" ? theme.colors.coreLight : theme.colors.textHeading};

  a {
    color: ${({ theme, $color }) =>
      $color === "purple" ? theme.colors.coreLight : theme.colors.textHeading};

    &:hover {
      text-decoration: underline;
    }
  }

  nav.breadcrumb {
    font-size: 14px;
    display: flex;
  }

  .breadcrumb__link {
    font-family: "Frutiger Bold";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.14px;
    text-decoration: none;
    padding: 0 2px;
  }

  .breadcrumb__separator {
    font-family: "Frutiger Bold";
    font-size: 14px;
    height: fit-content;
    align-self: flex-end;
  }
`;

const Link = styled(GatsbyLink)`
  font-family: "Frutiger Bold";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.14px;
  text-decoration: none;
`;

const Text = styled.span`
  font-family: "Frutiger Bold";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.14px;
`;

const Separator = styled(Text)`
  &:first-child,
  &:last-child {
    display: none;
  }
`;

const S = {
  Wrapper,
  Separator,
  Link,
  Text,
};

export default S;
